import React from 'react';
import { Link } from 'react-router';
import styles from '../css/Main.css';

import Navigation from '../components/Navigation.js';

import photo3 from '../../design/photos/arbeiten/_HUM2691 - Farbe.jpg';
import photo4 from '../../design/photos/arbeiten/R3.jpg';
import photo1 from '../../design/photos/schalen/Ruoff_091114_0046_w.jpg';
// import photo2 from '../../design/photos/schalen/Ruoff_091114_0046_w.jpg';
import photo2 from '../../design/photos/arbeiten/_HUM2433.jpg';
import photo5 from '../../design/photos/schalen/DSCN0556A.jpg';

export default function ArbeitenHome(props) {
  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <p className={styles.titleleft}>Hanna Schneider</p>
        <p className={styles.titleright}>Keramik</p>
      </div>
      <div className={styles.content}>
        <Link className={styles.photoText} to="arbeiten/schalen">
          <img alt={1} className={styles.photos2} src={photo5} />
          <p className={styles.photoText}>Gefässe</p>
        </Link>
        <Link className={styles.photoText} to="arbeiten/objekte">
          <img alt={1} className={styles.photos2} src={photo2} />
          <p className={styles.photoText}>Objekte</p>
        </Link>
        <Link className={styles.photoText} to="arbeiten/neriage">
          <img alt={1} className={styles.photos2} src={photo3} />
          <p className={styles.photoText}>Neriage</p>
        </Link>
        <Link className={styles.photoText} to="arbeiten/rauchverband">
          <img alt={1} className={styles.photos2} src={photo4} />
          <p className={styles.photoText}>Rauchbrand</p>
        </Link>
      </div>
      {props.children}
      <Navigation />
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/ArbeitenHome.js